import type { FC } from 'react';
import React, { useState } from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import { PlusIcon } from '@setup/svg-icons/svg-icons';
import { StyledAddItemContainer } from '@shared/ui/containers/AddItemContainer/AddItemContainer.style';

type AddItemContainerProps = {
  label: string;
  isFullWidth?: boolean;
  isFullHeight?: boolean;
  isDisabled?: boolean;
  variant?: 'default' | 'shortHeight' | 'shortWidth';
  callback?: () => void;
  description?: string;
};
export const AddItemContainer: FC<AddItemContainerProps> = ({
  label,
  variant = 'default',
  isFullWidth,
  isDisabled,
  isFullHeight,
  callback,
  description,
}) => {
  const theme = useTheme();

  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    if (!isDisabled) {
      callback?.();
      setIsClicked(true);
      setTimeout(() => setIsClicked(false), 300);
    }
  };

  return (
    <StyledAddItemContainer
      variant={variant}
      isDisabled={isDisabled}
      isClicked={isClicked}
      isFullHeight={isFullHeight}
      isFullWidth={isFullWidth}
      onClick={handleClick}
    >
      {description && (
        <Typography
          textAlign={'center'}
          p={'0 16px'}
          mb={'8px'}
          color={theme.palette.case.neutral.n600}
          variant={'t14r'}
        >
          {description}
        </Typography>
      )}

      <Box display={'flex'} alignItems={'center'} flexShrink={0}>
        <PlusIcon />
        {variant !== 'shortWidth' && (
          <Typography marginLeft={'8px'} variant={'button1'}>
            {label}
          </Typography>
        )}
      </Box>
    </StyledAddItemContainer>
  );
};
